import "./App.css";
import "./fonts/Namecat.ttf";
import "./fonts/Slowdex.ttf";
import Header from "./composants/Header.js";
import Footer from "./composants/Footer.js";
import Quisuisje from "./composants/Quisuisje.js";
import Webdesign from "./composants/Webdesign.js";
import Logo from "./composants/Logo.js";
import Creation from "./composants/Creation.js";
import BackgroundMusic from "./composants/Music.js";
import Background from "./composants/Background.js";
import WhoAmI from "./composants/WhoAmI.js";


function App() {
  return (
    <div className="app">
      <Header />
      <div className="app__content">
        <Background />
        <WhoAmI />
        <Quisuisje />
        <Webdesign />
        <Creation />
        <Logo />
      </div>
      <Footer />
      <BackgroundMusic />
    </div>
  );
}

export default App;
